import { EMPTY, from } from "rxjs";
import { selectNonCollectibleProduct } from "../../../selectors/selectRecipeInfo";
import { selectWaterTowerProductInfo } from "../../../selectors/selectWatertowerInfo";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionQuickSellResourceInfo } from "../../quick-sell-dialog/actionQuickSell";
export var pathWaterTowerOpenQuickSell = function (action, state$, deps) {
    var state = state$.value;
    var productInfo = selectWaterTowerProductInfo(state);
    var actions = [];
    if (productInfo != undefined) {
        var nonCollectibleProduct = selectNonCollectibleProduct(state, [productInfo]);
        if (nonCollectibleProduct != undefined) {
            actions.push(actionQuickSellResourceInfo(nonCollectibleProduct));
            actions.push(actionModalOpen(IdModal.QuickSell));
            return from(actions);
        }
        return EMPTY;
    }
    return EMPTY;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/paths/pathWaterTowerOpenQuickSell.ts
// module id = 2508
// module chunks = 3